<template>
  <div class="col-12 mt-3">
    <div class="equip-accordion">
      <extra-equipment-group
        v-for="group in filtered(allEquipmentGroups)"
        :key="'extra_' + group.name"
        :group="group"
      />
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';
  import ExtraEquipmentGroup from './ExtraEquipmentGroup';

  const configuratorModule = namespace('configurator');
  @Component({
    components: {ExtraEquipmentGroup}
  })
  export default class ExtraEquipmentSelector extends Vue {
    @Prop() equipmentGroups;
    @Prop(Array) stockEqcodes;
    @Prop() stockSlug;

    @configuratorModule.State('stockMode') stockMode;
    @configuratorModule.State('selectedEquipments') selectedEquipments;
    @configuratorModule.Getter('getEquipmentGroups') allEquipmentGroups;
    @configuratorModule.Action('loadEquipmentGroups') loadEquipmentGroups;
    @configuratorModule.Action('loadStock') loadStock;
    @configuratorModule.Mutation('setStockSlug') setStockSlug;

    created() {
      this.loadEquipmentGroups(this.equipmentGroups);

      if (this.stockSlug.length > 0) {
        this.loadStock({stockEqCodes: this.stockEqcodes, slug: this.stockSlug});
      }
    }

    filtered(groups) {
      if (this.stockMode) {
        return groups
          .filter(group => {
            return group.items
              .filter(equipment => {
                return this.selectedEquipments.includes(equipment.ADDID)
              }).length > 0
          })
      }

      return groups;
    }
  }
</script>

<style scoped>
.equip-accordion {
  border: 1px solid #e5e7eb;
  border-radius: 4px;
  overflow: hidden;
}
</style>
